var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.flag == _vm.index && _vm.detailShow
    ? _c(
        "div",
        { staticClass: "threads-box", attrs: { id: "threadsBox" } },
        [
          _c("div", { staticClass: "threads-title" }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("language.common.targetCloud")))])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "thread-box",
              class: _vm.collapseIndex == -2 ? "collapse-thread-box" : "",
              style: { height: _vm.collapseIndex == -2 ? 240 + "px" : "" }
            },
            [
              _c("div", { staticClass: "thread-all-backgroud" }, [
                _c("div", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showStatus(_vm.syncItem) == "threadPercent",
                      expression: "showStatus(syncItem)=='threadPercent'"
                    }
                  ],
                  staticClass: "thread-all-back",
                  style: { width: _vm.syncItem.percent + "%" }
                })
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "thread-detail-bottom" },
                [
                  _c("div", { staticClass: "thread-name" }, [
                    _c("div", { staticStyle: { float: "left" } }, [
                      _vm._v(_vm._s(_vm.$t("language.common.target")) + ": ")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "thread-catelog",
                        attrs: {
                          title: _vm._f("getCatalogTitle")(
                            _vm._f("getCatalog")(_vm.syncItem.toItem.nodes)
                          )
                        },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.toAimCatalog(_vm.syncItem)
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm._f("getCatalog")(_vm.syncItem.toItem.nodes)
                          )
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "icon-util  white-up-position",
                    class: _vm.collapseIndex == -2 ? "purple-down" : "white-up",
                    on: {
                      click: function($event) {
                        return _vm.collapsePage(-2, _vm.syncItem)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "thread-status" }, [
                    _vm.showStatus(_vm.syncItem) == "threadPercent"
                      ? _c("div", { staticClass: "thread-status-name" }, [
                          _vm.syncItem.percent
                            ? _c("div", [
                                _vm._v(_vm._s(_vm.syncItem.percent) + "%")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.syncItem.percent
                            ? _c("div", [_vm._v("0%")])
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showStatus(_vm.syncItem) == "threadFailure"
                      ? _c("div", { staticClass: "thread-status-name" }, [
                          _vm._v(_vm._s(_vm.$t("language.common.failure")))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showStatus(_vm.syncItem) == "particalStatus"
                      ? _c(
                          "div",
                          { staticClass: "thread-status-name partical-color" },
                          [_vm._v(_vm._s(_vm.$t("language.common.patial")))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showStatus(_vm.syncItem) == "threadSuccess"
                      ? _c(
                          "div",
                          { staticClass: "thread-status-name color-green" },
                          [_vm._v(_vm._s(_vm.$t("language.common.success")))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showStatus(_vm.syncItem) == "threadWaiting"
                      ? _c("div", { staticClass: "thread-status-name" }, [
                          _vm._v(
                            _vm._s(_vm.$t("language.common.waiting")) + "..."
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showStatus(_vm.syncItem) == "threadCancel"
                      ? _c("div", { staticClass: "thread-status-name" }, [
                          _vm._v(_vm._s(_vm.$t("language.common.canceled")))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showStatus(_vm.syncItem) == "threadCount"
                      ? _c("div", { staticClass: "thread-status-name" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("language.common.countFiles")) +
                              ":(" +
                              _vm._s(
                                _vm.syncItem.syncDetail.readyFindFileCount
                              ) +
                              _vm._s(_vm.$t("language.common.transferFiles")) +
                              "," +
                              _vm._s(
                                _vm._f("formatByte")(
                                  _vm.syncItem.syncDetail.totalBytes
                                )
                              ) +
                              ")"
                          )
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("transition", { attrs: { name: "thread" } }, [
                    _vm.collapseIndex == -2
                      ? _c("div", { staticClass: "sync-threads-detail" }, [
                          _c(
                            "div",
                            { staticClass: "thread-detail" },
                            [
                              _c("sync-detail", {
                                ref: "syncThreadDetail",
                                attrs: {
                                  threadChange: _vm.threadChange,
                                  flag: _vm.collapseIndex,
                                  index: -2,
                                  detailShow: _vm.detailShow,
                                  itemSyncDetail: _vm.syncItem
                                }
                              })
                            ],
                            1
                          )
                        ])
                      : _vm._e()
                  ])
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _vm._l(_vm.syncItem.sources, function(itemSyncDetail, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "thread-box",
                class: _vm.collapseIndex == index ? "collapse-thread-box" : "",
                style: { height: _vm.collapseIndex == index ? 240 + "px" : "" }
              },
              [
                _c("div", { staticClass: "thread-all-backgroud" }, [
                  _c("div", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.showStatus(itemSyncDetail) == "threadPercent",
                        expression:
                          "showStatus(itemSyncDetail)=='threadPercent'"
                      }
                    ],
                    staticClass: "thread-all-back",
                    style: { width: itemSyncDetail.percent + "%" }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "thread-detail-bottom" },
                  [
                    _c("div", { staticClass: "thread-name" }, [
                      _c("div", { staticStyle: { float: "left" } }, [
                        _vm._v(_vm._s(_vm.$t("language.common.target")) + ": ")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "thread-catelog",
                          attrs: {
                            title: _vm._f("getCatalogTitle")(
                              _vm._f("getCatalog")(itemSyncDetail.toItem.nodes)
                            )
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.toAimCatalog(itemSyncDetail)
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm._f("getCatalog")(itemSyncDetail.toItem.nodes)
                            )
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "thread-status" }, [
                      _vm.showStatus(itemSyncDetail) == "threadPercent"
                        ? _c("div", { staticClass: "thread-status-name" }, [
                            _c("div", [
                              _vm._v(_vm._s(itemSyncDetail.percent) + "%")
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showStatus(itemSyncDetail) == "threadFailure"
                        ? _c("div", { staticClass: "thread-status-name" }, [
                            _vm._v(_vm._s(_vm.$t("language.common.failure")))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showStatus(itemSyncDetail) == "particalStatus"
                        ? _c(
                            "div",
                            {
                              staticClass: "thread-status-name partical-color"
                            },
                            [_vm._v(_vm._s(_vm.$t("language.common.patial")))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showStatus(itemSyncDetail) == "threadSuccess"
                        ? _c(
                            "div",
                            { staticClass: "thread-status-name color-green" },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("language.common.success"))
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showStatus(itemSyncDetail) == "threadWaiting"
                        ? _c("div", { staticClass: "thread-status-name" }, [
                            _vm._v(
                              _vm._s(_vm.$t("language.common.waiting")) + "..."
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showStatus(itemSyncDetail) == "threadCancel"
                        ? _c("div", { staticClass: "thread-status-name" }, [
                            _vm._v(_vm._s(_vm.$t("language.common.canceled")))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showStatus(itemSyncDetail) == "threadCount"
                        ? _c("div", { staticClass: "thread-status-name" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("language.common.countFiles")) +
                                ":(" +
                                _vm._s(
                                  itemSyncDetail.syncDetail.readyFindFileCount
                                ) +
                                _vm._s(
                                  _vm.$t("language.common.transferFiles")
                                ) +
                                "," +
                                _vm._s(
                                  _vm._f("formatByte")(
                                    itemSyncDetail.syncDetail.totalBytes
                                  )
                                ) +
                                ")"
                            )
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "icon-util  white-up-position",
                      class:
                        _vm.collapseIndex == index ? "purple-down" : "white-up",
                      on: {
                        click: function($event) {
                          return _vm.collapsePage(index, itemSyncDetail)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("transition", { attrs: { name: "thread" } }, [
                      _vm.collapseIndex == index
                        ? _c("div", { staticClass: "sync-threads-detail" }, [
                            _c(
                              "div",
                              { staticClass: "thread-detail" },
                              [
                                _c("sync-detail", {
                                  ref: "syncThreadDetail",
                                  refInFor: true,
                                  attrs: {
                                    flag: _vm.collapseIndex,
                                    index: index,
                                    detailShow: _vm.itemDetailShow,
                                    threadChange: _vm.threadChange,
                                    itemSyncDetail: itemSyncDetail
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        : _vm._e()
                    ])
                  ],
                  1
                )
              ]
            )
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1059068b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1059068b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/tabs/tabs_task_list/tabs_sync_threads.vue
// module id = null
// module chunks = 